cockpitApp.controller('locationNameController', [
  '$scope', 'segmentHelper', 'locationHelper',
  function($scope, segmentHelper, locationHelper)
  {
    $scope.segmentHelper = segmentHelper;
    $scope.locationHelper = locationHelper;
  }
]);
